import apiClient from './config';
import BLOG_ENDPOINTS from './endpoints/blogEndpoints';

const blogService = {
  getBlogs: (params) => {
    return apiClient.get(BLOG_ENDPOINTS.GET_BLOGS, { params });
  },

  getBlogDetail: (slug) => {
    return apiClient.get(`${BLOG_ENDPOINTS.GET_BLOG_DETAIL}/${slug}`);
  },

  getCategories: () => {
    return apiClient.get(BLOG_ENDPOINTS.GET_BLOG_CATEGORIES);
  },

  getComments: (slug, params) => {
    return apiClient.get(`${BLOG_ENDPOINTS.BLOG_COMMENTS}/${slug}/comments`, { params });
  },

  createComment: (slug, data) => {
    return apiClient.post(`${BLOG_ENDPOINTS.BLOG_COMMENTS}/${slug}/comments`, data);
  },

  createCommentReply: (commentId, data) => {
    return apiClient.post(`${BLOG_ENDPOINTS.BLOG_COMMENT_REPLY}/${commentId}/reply`, data);
  },

  subscribeNewsletter: (data) => {
    return apiClient.post(BLOG_ENDPOINTS.BLOG_NEWSLETTER_SUBSCRIBE, data);
  },

  unsubscribeNewsletter: (data) => {
    return apiClient.post(BLOG_ENDPOINTS.BLOG_NEWSLETTER_UNSUBSCRIBE, data);
  },

  // One-click unsubscribe from a campaign email's link. `format=json` tells
  // the backend this is an AJAX fetch (always respond with JSON), as opposed
  // to a real browser navigation, which the backend would redirect instead.
  unsubscribeByToken: (token) => {
    return apiClient.get(`${BLOG_ENDPOINTS.EMAIL_TRACK_UNSUBSCRIBE}/${token}`, {
      params: { format: 'json' },
    });
  },
};

export default blogService;
